export default function Nav({ t, lang, setLang }) {
  return (
    <nav className="nav">
      <a href="#" className="nav-logo">A<span>2</span>G</a>
      <ul className="nav-links">
        <li><a href="#videos">{t.nav_videos}</a></li>
        <li><a href="#how">{t.nav_how}</a></li>
        <li><a href="#inquiry">{t.nav_inquiry}</a></li>
      </ul>
      <div className="nav-right">
        <div className="lang-switcher">
          {['ko', 'en', 'ru'].map((l) => (
            <button
              key={l}
              className={`lang-btn${lang === l ? ' active' : ''}`}
              onClick={() => setLang(l)}
            >
              {l.toUpperCase()}
            </button>
          ))}
        </div>
        <a href="#inquiry" className="nav-cta">{t.nav_cta}</a>
      </div>
    </nav>
  )
}
